$(document).ready(
    function () {

        $(document).on("submit", "#event_subevent_deviation_register_form", function (e) {

            e.preventDefault();

            $.ajax({
                type: 'POST',
                url: "/ajax/organizer_event_subevent/new",
                data: {
                    serialized_post: $(this).serialize()
                }
            })
                .done(function (data) {

                    if (data == true) {
                        popupAlert();
                        setTimeout(function () {
                            document.location.reload();
                        }, 1000);
                    }

                })
                .fail(function (data) {

                    if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                        document.location.href = data.responseJSON.redirect_url;
                    }

                    if (data.responseJSON.error_message !== undefined && data.responseJSON.error_message !== null) {
                        prependAlert('#div_event_subevent_deviation_button_wrapper', data.responseJSON.error_message, 'danger', null, '#event_subevent_deviation_register_form')
                    }

                });

        });

        $(document).on("change", '#event_subevent_deviation_register_form #timeslot-minutes-checkbox', function () {
            if ($('#timeslot-minutes-checkbox').prop("checked") === true) {
                $('#timeslot-minutes-input-container').removeClass('d-none');
                $('#timeslot-average-duration-input-container').removeClass('d-none');
            } else {
                if (!$('#timeslot-minutes-input-container').hasClass('d-none')) {
                    $('#timeslot-minutes-input-container').addClass('d-none');
                }
                if (!$('#timeslot-average-duration-input-container').hasClass('d-none')) {
                    $('#timeslot-average-duration-input-container').addClass('d-none');
                }

                if (!$('#max-tickets-timeslot-label').hasClass('d-none')) {
                    $('#max-tickets-timeslot-label').addClass('d-none');
                }
            }
        });


    }
);